/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum CustomerAccessTypeApiModel {
  FullBonusesAccess = 'full-bonuses-access',

  AddBonusesOnly = 'add-bonuses-only',

  WaitingForConfirmation = 'waiting-for-confirmation',

  InBlackList = 'in-black-list'
}
